import { z } from 'zod';

export const DISPLAY_NAME_MAX_LENGTH = 100;

/**
 * @link https://github.com/lessonup/lessonup/blob/a3ac598bc65668a5d456f348e2e8ac9ac3eec5b1/libs/lessonup-core/src/domain/entries/AssignmentEntry.ts
 */
const DbAssignmentEntrySchema = z.object({
  _id: z.string(),
  userId: z.string(),
  assignmentId: z.string(),
});

export type DbAssignmentEntry = z.infer<typeof DbAssignmentEntrySchema>;

type CreateEntryIdArgs = {
  userId: string;
  assignmentId: string;
};

export function createEntryId({ userId, assignmentId }: CreateEntryIdArgs) {
  return `${assignmentId}-${userId}`;
}

export function isOwnerOfEntry(userId: string, entry: DbAssignmentEntry): boolean {
  return entry.userId === userId;
}
